import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24 px-4 md:px-10">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 rounded-full text-xs font-semibold uppercase tracking-wide mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Common Questions About{' '}
            <span className="italic text-primary-500">Superbuy Spreadsheet</span>
          </h2>
          <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Everything you need to know about using Superbuy Spreadsheet for smarter product research
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <div className="flex items-center gap-4">
                  <span className="w-7 h-7 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-xs font-bold text-accent-700">Q{idx + 1}</span>
                  </span>
                  <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {item.question}
                  </span>
                </div>
                {openIndex === idx ? (
                  <i className="ri-arrow-up-s-line text-foreground-400 text-lg flex-shrink-0"></i>
                ) : (
                  <i className="ri-arrow-down-s-line text-foreground-400 text-lg flex-shrink-0"></i>
                )}
              </button>

              {openIndex === idx && (
                <div className="px-6 pb-5 pl-[68px]">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}